import { render } from "./FailedResults.vue?vue&type=template&id=3454e4d6"
import script from "./FailedResults.vue?vue&type=script&lang=js"
export * from "./FailedResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/FailedResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3454e4d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3454e4d6', __exports__)) {
    console.log('reload')
    api.reload('3454e4d6', __exports__)
  }
  
  module.hot.accept("./FailedResults.vue?vue&type=template&id=3454e4d6", () => {
    console.log('re-render')
    api.rerender('3454e4d6', render)
  })

}


export default __exports__